import { useEffect, useState } from "react";
import { Paper, Title, Text, Stack, Skeleton, Group } from "@mantine/core";
import moment from "moment";
import * as apiService from "../../api-service";
import { IconBrandAndroid } from "@tabler/icons";
import IconBadge from "../../components/IconBadge";

const ANDROID_COLOR = "#0f9d58";

export default function ModuleGoogleReleases() {
  const [isLoading, setIsLoading] = useState(true);
  const [release, setRelease] = useState(null);

  useEffect(() => {
    apiService
      .getGoogleReleases()
      .then((data) => {
        setRelease(data);
        setIsLoading(false);
      })
      .catch((data) => {
        console.error(data);
        setIsLoading(false);
      });
  }, []);

  return (
    <Paper shadow="sm" radius="md" p="md" withBorder>
      <Group spacing="sm" noWrap align="flex-start">
        <IconBadge color={ANDROID_COLOR} icon={<IconBrandAndroid size={20} stroke={2.5} color={ANDROID_COLOR} />} />
        <Stack spacing={0} sx={{ minWidth: 0, flex: 1 }}>
          <Text size="xs" fw={700} tt="uppercase" color="dimmed" sx={{ letterSpacing: 0.4 }}>
            Latest Android Release
          </Text>
          {isLoading ? (
            <Stack spacing="xs" p={2}>
              <Skeleton height={28} radius="sm" />
              <Skeleton height={18} radius="sm" />
            </Stack>
          ) : (
            <>
              {/* No line clamp - wraps onto a second line instead of being cut off. */}
              <Title order={2} weight={800}>
                {release?.title ?? "Unavailable"}
              </Title>
              <Title order={5} weight={300} color="dimmed">
                {release?.pubDate ? moment(release.pubDate).format("ddd, DD MMM YYYY") : "Release date unavailable"}
              </Title>
            </>
          )}
        </Stack>
      </Group>
    </Paper>
  );
}
